import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage, FormattedDate } from 'dibs-react-intl';

//Components

import styles from './styles/checkoutCreditCardView.scss';

const CheckoutCreditCardView = props => {
    const {
        creditCard,
        hideExpiredText = false,
        hideName = false,
        hideMaskedCard = false,
        hideExpiration = false,
        showTitle = false,
    } = props;
    const {
        cardType,
        cardHolderName,
        formattedTextMaskedCardNumber,
        cardExpiryMonth,
        cardExpiryYear,
        cardLogo,
        isExpired,
    } = creditCard || {};

    // month is 0 indexed in js Date constructor
    const expirationDate = (
        <FormattedDate
            value={new Date(cardExpiryYear, Number(cardExpiryMonth) - 1)}
            year="numeric"
            month="2-digit"
        />
    );
    let expirationMessage = expirationDate;
    if (isExpired) {
        expirationMessage = (
            <FormattedMessage
                id="checkout.CheckoutCreditCardView.expiration"
                defaultMessage="{expirationDate} - expired"
                values={{ expirationDate }}
            />
        );
    }

    const expirationClasses = classNames(styles.expirationDate, {
        [styles.expired]: !hideExpiredText && isExpired,
    });
    const maskedCardClasses = classNames(styles.maskedCard, {
        [styles.showTitle]: showTitle || !hideName,
        [styles.showExpiration]: !hideExpiration,
    });

    return (
        <div className={styles.wrapper}>
            {showTitle && (
                <div data-tn="card-title">
                    <FormattedMessage
                        id="checkout.CheckoutCreditCardView.cardTitle"
                        defaultMessage="Credit/Debit Card"
                    />
                </div>
            )}
            {!hideName && <div data-tn="card-holder-name">{cardHolderName}</div>}
            {!hideMaskedCard && (
                <div className={maskedCardClasses} data-tn="card-masked-number">
                    {!!cardLogo && <img className={styles.logo} src={cardLogo} alt={cardType} />}
                    <div>{formattedTextMaskedCardNumber}</div>
                </div>
            )}
            {!hideExpiration && (
                <div className={expirationClasses} data-tn="card-expiration-date">
                    {expirationMessage}
                </div>
            )}
        </div>
    );
};

CheckoutCreditCardView.propTypes = {
    creditCard: PropTypes.object.isRequired,
    hideExpiredText: PropTypes.bool,
    hideName: PropTypes.bool,
    hideMaskedCard: PropTypes.bool,
    hideExpiration: PropTypes.bool,
    hideMessage: PropTypes.bool,
    showTitle: PropTypes.bool,
};

export default createFragmentContainer(CheckoutCreditCardView, {
    creditCard: graphql`
        fragment CheckoutCreditCardView_creditCard on CreditCard {
            cardType
            cardLogo
            cardHolderName
            cardExpiryMonth
            cardExpiryYear
            formattedTextMaskedCardNumber
            isExpired
        }
    `,
});
